export default {
    SELECT_OBJECT: "Выберите один или несколько объектов документа",
    NO_AVAILABLE_SCRIPTS: "Нет сохраненных скриптов"
};
